import type { AttachedFile } from '../state/types';
import { formatBytes } from './format';
import { makeLocalId } from './id';

/**
 * Vertaalt een lijst native `File`-objects naar onze interne `AttachedFile`-
 * shape: assignment van een lokale ID + size-label + kind-classificatie.
 * Pure functie — geen DOM, geen state, direct te unit-testen.
 *
 * Kind-detectie via MIME-type met fallback op file-extensie voor PDFs
 * (sommige browsers laten PDF-MIME leeg op drag-drop).
 */
export function mapFilesToAttachments(files: File[]): AttachedFile[] {
  return files.map((f) => ({
    id: makeLocalId(),
    name: f.name,
    sizeLabel: formatBytes(f.size),
    kind: f.type.startsWith('image/')
      ? 'image'
      : f.type === 'application/pdf' || f.name.endsWith('.pdf')
        ? 'pdf'
        : 'file',
  }));
}
